"use client";

import { addSearchTerm, readSearchHistory, removeSearchTerm } from "@/utils/searchHistoryStorage";
import { useCallback, useEffect, useState } from "react";

/**
 * Every write must refresh state, not just storage: searching uses router.push, which leaves
 * the header mounted, so a mount-only read leaves the just-searched term missing from the
 * dropdown until the next full page load.
 */
export const useSearchHistory = (): SearchHistory => {
  // Read in an effect, not a useState initializer, so SSR and hydration agree on an empty list.
  const [searchHistory, setSearchHistory] = useState<string[]>([]);

  useEffect(() => {
    setSearchHistory(readSearchHistory());
  }, []);

  const recordSearch = useCallback((searchTerm: string | null | undefined) => {
    setSearchHistory(addSearchTerm(searchTerm));
  }, []);

  const forgetSearch = useCallback((searchTerm: string) => {
    setSearchHistory(removeSearchTerm(searchTerm));
  }, []);

  return { searchHistory, recordSearch, forgetSearch };
};

interface SearchHistory {
  searchHistory: string[];
  recordSearch: (searchTerm: string | null | undefined) => void;
  forgetSearch: (searchTerm: string) => void;
}
